'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _reactRouterDom = require("react-router-dom");
var _AppWrapper = _interopRequireDefault(require("AppWrapper"));
var _PagesExports = _interopRequireDefault(require("PagesExports"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let app = window.app;
const EMPTY_SESSION = {
  user: {
    roles: []
  },
  allowed_routes: []
};
class Application extends _react.Component {
  state = {
    session: EMPTY_SESSION,
    allowed_routes: [],
    loading: true
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange,
      global: true
    });
    app.push({
      event: 'sessionNeedsRefresh',
      cb: component.refreshSession,
      global: true
    });
    app.push({
      event: 'logout',
      cb: component.handleLogout,
      global: true
    });
    component.refreshSession({
      source: 'initState'
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange,
      global: true
    });
    app.delete({
      event: 'sessionNeedsRefresh',
      cb: component.refreshSession,
      global: true
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const allowed_routes = (app.state.session.customized_authorizations || []).filter(action => action.front?.url && action.front?.reactComponent).reduce(function (accumulator, action) {
      accumulator[action.front.url] = {
        id: action.id,
        type: action.type,
        roles: action.roles,
        exact: action.front.exact !== false,
        component: _PagesExports.default[action.front.reactComponent],
        allowed: action.allowed
      };
      return accumulator;
    }, {});
    if ((0, _isEqual2.default)(state.allowed_routes, allowed_routes)) {
      return;
    }
    component.setState({
      allowed_routes: allowed_routes
    });
  };
  handleLogout = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/get-session').then(function (xhr, response) {
      app.state.session = response || undefined;
      app.navigateTo('/');
      app.emit({
        event: 'sessionChange',
        source: component
      });
      component.setState({
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  refreshSession = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/get-session').then(function (xhr, response) {
      app.state.session = response || undefined;
      app.emit({
        event: 'sessionChange',
        source: component
      });
      component.setState({
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const user = app.state.session.user ? app.state.session.user || {
      roles: []
    } : {
      roles: []
    };
    const is__authenticated = user.id !== undefined;
    const is__admin = (user.roles || []).includes('admin');
    const roles = is__authenticated ? user.roles || [] : [];
    let rendered_routes = Object.keys(state.allowed_routes || {}).map(function (path, i) {
      let page_component = state.allowed_routes[path].component;
      let role_type = state.allowed_routes[path].type;
      let allowed_roles = state.allowed_routes[path].roles;
      let exact = state.allowed_routes[path].exact !== false;
      let is__allowed = false;
      if (is__admin || role_type === 'public') {
        is__allowed = true;
      } else if (role_type === 'connected' && is__authenticated) {
        is__allowed = true;
      } else {
        is__allowed = (0, _intersection2.default)(allowed_roles, roles).length > 0;
      }
      const route = is__allowed ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        exact: exact,
        path: path,
        component: page_component,
        key: i
      }) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        exact: exact,
        path: path,
        component: _PagesExports.default['NotAllowedPage'],
        key: i
      });
      return route;
    });
    rendered_routes.push(/*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      component: _PagesExports.default['NotFoundPage'],
      key: rendered_routes.length
    }));
    let output = /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_AppWrapper.default, {
      routes: rendered_routes
    }));
    const loader = /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    });
    return state.loading ? loader : output;
  }
}
exports.default = Application;
